import { FormEvent } from 'react';
import { Nav } from 'react-bootstrap';
import { NavWrapper, NavItemWrapper } from './styles';
import { useMediaQuery } from 'react-responsive';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    activeKey: string,
    centerId: number,
    isAdmin: boolean,
    centerAdmin: boolean
    onTabSelect: (key: string) => void,
}

const CenterNav = (props: IProps) => {
    const { app: { site } } = useAppHookContext();
    const isBigScreen = useMediaQuery({ minWidth: 1824 });

    const handleSelect = (e: FormEvent<Nav>) => {
        props.onTabSelect(e['eventKey']);
    };

    const { activeKey, centerId, isAdmin, centerAdmin } = props;
    const urlPrefix = !props.isAdmin ? `center/${centerId}/profile` : `admin/center/${centerId}/profile`;
    const tabWidth = isBigScreen ? '150' : 'initial';
    const fontSize = isBigScreen ? '14px' : '12px';

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ddd' }}>
            <NavWrapper bsStyle='tabs' activeKey={activeKey} tabWidth={tabWidth} fontSize={fontSize} onSelect={handleSelect}>
                <NavItemWrapper eventKey='EDIT' href={urlPrefix + '/edit'}>
                    Edit
                </NavItemWrapper>

                <NavItemWrapper eventKey="ADDRESSES" href={urlPrefix + '/addresses'} tabWidth={tabWidth}>
                    Addresses
                </NavItemWrapper>

                <NavItemWrapper eventKey='CONTACTS' href={urlPrefix + '/contacts'}>
                    Contacts
                </NavItemWrapper>

                {(isAdmin || centerAdmin) && (
                    <NavItemWrapper eventKey='USERS' href={urlPrefix + '/users'}>
                        Users
                    </NavItemWrapper>
                )}

                <NavItemWrapper eventKey="REFERRAL-CONFIG" href={isAdmin ? "/admin/center/" + centerId + "/profile/referral-config" : urlPrefix + "/referral-config"} tabWidth={tabWidth}>
                    DASH / Referral Config
                </NavItemWrapper>     

                {site.organType == OrganType.Kidney && (
                    <>
                        <NavItemWrapper eventKey='WAITLIST-CONFIG' href={urlPrefix + '/waitlist-config'}>
                            Waitlist Allocation
                        </NavItemWrapper>

                        <NavItemWrapper eventKey="FU-LAB-OPTION" href={urlPrefix + '/followup-lab-option'} tabWidth={tabWidth}>
                            F/U Lab Options
                        </NavItemWrapper>

                        <NavItemWrapper eventKey="CHEEK-SWAB-REQUEST" href={urlPrefix + '/cheek-swab-request'} tabWidth={tabWidth}>
                            Order Bulk Cheek Swabs
                        </NavItemWrapper>
                    </>
                )}

                {props.activeKey == 'EDIT-CONTACT' && (
                    <NavItemWrapper eventKey="EDIT-CONTACT" tabWidth={tabWidth}>
                        Edit Contact
                    </NavItemWrapper>
                )}

                {props.activeKey == 'ADD-CONTACT' && (
                    <NavItemWrapper eventKey='ADD-CONTACT'>
                        Add Contact
                    </NavItemWrapper>
                )}
            </NavWrapper>
        </div >
    );
}

export default CenterNav;
